import ChatBody from "./ChatBodyContainer";

export default ChatBody;
